import React from "react";
import "./styles/DetallePago.css";
import {
    EFECTIVO,
    MASTER,
    POS,
    AMERICAN,
    OTROS,
    PAGO_CREDITO,
    FPAY, decimalAdjust, PLIN, RAPPI, TUNKI, YAPE
} from "../../Global";
import EfectivoImg from "./images/efectivo.png";
import Mastercard from "./images/mastercard.png";
import Pos from "./images/pos-icon.png";
import American from "./images/american.png";
import OtrosPagos from "./images/otros.png";
import Credito from "./images/credito.png";
import Fpay from "./images/fpy.jpeg";
import Yape from "./images/yape.png";
import Plin from "./images/plin logo.png";
import Rappi from "./images/rappi logo.png";
import Tunki from "./images/tunki logo.png";
import moment from "moment";

// Mapeo de imágenes y nombres para evitar duplicación
const paymentData = {
    [EFECTIVO]: { src: EfectivoImg, className: "btn-outline-success", name: "Efectivo" },
    [MASTER]: { src: Mastercard, className: "btn-outline-danger", name: "Mastercard" },
    [POS]: { src: Pos, className: "btn-outline-secondary", name: "POS" },
    [AMERICAN]: { src: American, className: "btn-outline-info", name: "American Express" },
    [OTROS]: { src: OtrosPagos, className: "btn-outline-warning", name: "Otros" },
    [PAGO_CREDITO]: { src: Credito, className: "btn-outline-danger", name: "Crédito" },
    [FPAY]: { src: Fpay, className: "btn-outline-danger", name: "Fpay" },
    [PLIN]: { src: Plin, className: "btn-outline-info", name: "Plin" },
    [RAPPI]: { src: Rappi, className: "btn-outline-warning", name: "Rappi" },
    [TUNKI]: { src: Tunki, className: "btn-outline-danger", name: "Tunki" },
    [YAPE]: { src: Yape, className: "btn-outline-danger", name: "Yape" },
};

const DetallePagoUI = props => {
    const paymentInfo = paymentData[props.IdTipoPago];
    
    // Renderizar botón de eliminar
    const renderDeleteButton = () => (
        props.IdTipoPago === FPAY ? (
            <div className="invisible">
                <button
                    type="button"
                    className="boton__outline-pequeno--r"
                    onClick={props.handleRemovePago}
                >
                    <i className="fas fa-trash-alt"/>
                </button>
            </div>
        ) : (
            <button
                type="button"
                className="boton__outline-pequeno--r"
                onClick={props.handleRemovePago}
            >
                <i className="fas fa-trash-alt"/>
            </button>
        )
    );

    // Función para obtener estilos de la insignia con colores hexadecimales
    const getBadgeStyle = () => {
        const colorMap = {
            [EFECTIVO]: { backgroundColor: "#28a745", color: "#ffffff" },          // Verde
            [MASTER]: { backgroundColor: "#dc3545", color: "#ffffff" },            // Rojo
            [POS]: { backgroundColor: "#6c757d", color: "#ffffff" },               // Gris
            [AMERICAN]: { backgroundColor: "#17a2b8", color: "#ffffff" },          // Azul claro
            [OTROS]: { backgroundColor: "#ffc107", color: "#212529" },             // Amarillo (texto oscuro)
            [PAGO_CREDITO]: { backgroundColor: "#dc3545", color: "#ffffff" },      // Rojo
            [FPAY]: { backgroundColor: "#dc3545", color: "#ffffff" },              // Rojo
            [PLIN]: { backgroundColor: "#17a2b8", color: "#ffffff" },              // Azul claro
            [RAPPI]: { backgroundColor: "#ffc107", color: "#212529" },             // Amarillo
            [TUNKI]: { backgroundColor: "#dc3545", color: "#ffffff" },             // Rojo
            [YAPE]: { backgroundColor: "#800080", color: "#ffffff" },              // Morado
        };
        return colorMap[props.IdTipoPago] || { backgroundColor: "#6c757d", color: "#ffffff" };
    };

    // Obtener los estilos para el badge
    const badgeStyle = getBadgeStyle();

    return (
        <div className="detalle__pago">
            <div className="items__detalle__pago botones-desk">
                {props.IdTipoPago === EFECTIVO && (
                    <input
                        type="image"
                        src={EfectivoImg}
                        className="btn btn-outline-success item__detalle__pago--img"
                        alt="Tipo pago Efectivo"
                    />
                )}
                {props.IdTipoPago === MASTER && (
                    <input
                        type="image"
                        src={Mastercard}
                        className="btn btn-outline-danger item__detalle__pago--img"
                        alt="Tipo pago Master Card"
                    />
                )}
                {props.IdTipoPago === POS && (
                    <input
                        type="image"
                        src={Pos}
                        className="btn btn-outline-secondary item__detalle__pago--img"
                        alt="Tipo pago POS"
                    />
                )}
                {props.IdTipoPago === AMERICAN && (
                    <input
                        type="image"
                        src={American}
                        className="btn btn-outline-info item__detalle__pago--img"
                        alt="Tipo pago American"
                    />
                )}
                {props.IdTipoPago === OTROS && (
                    <input
                        type="image"
                        src={OtrosPagos}
                        className="btn btn-outline-warning item__detalle__pago--img"
                        alt="Tipo pago Otros"
                    />
                )}
                {props.IdTipoPago === PAGO_CREDITO && (
                    <div>
                        <input
                            type="image"
                            src={Credito}
                            className="btn btn-outline-danger item__detalle__pago--img"
                            alt="Tipo pago Crédito"
                        />
                    </div>
                )}
                {props.IdTipoPago === FPAY && (
                    <div>
                        <input
                            type="image"
                            src={Fpay}
                            className="btn btn-outline-danger item__detalle__pago--img"
                            alt="Tipo pago Fpay"
                        />
                    </div>
                )}
                {props.IdTipoPago === PLIN && (
                    <div>
                        <input
                            type="image"
                            src={Plin}
                            className="btn btn-outline-info item__detalle__pago--img"
                            alt="Tipo pago Plin"
                        />
                    </div>
                )}
                {props.IdTipoPago === RAPPI&& (
                    <div>
                        <input
                            type="image"
                            src={Rappi}
                            className="btn btn-outline-warning item__detalle__pago--img"
                            alt="Tipo pago Rappi"
                        />
                    </div>
                )}
                {props.IdTipoPago === TUNKI && (
                    <div>
                        <input
                            type="image"
                            src={Tunki}
                            className="btn btn-outline-danger item__detalle__pago--img"
                            alt="Tipo pago Tunki"
                        />
                    </div>
                )}
                {props.IdTipoPago === YAPE && (
                    <div>
                        <input
                            type="image"
                            src={Yape}
                            className="btn btn-outline-danger item__detalle__pago--img"
                            alt="Tipo pago Yape"
                        />
                    </div>
                )}
                <input
                    className="item__detalle__pago"
                    type="number"
                    autoFocus
                    onFocus={props.handleFocus}
                    placeholder="Monto"
                    value={decimalAdjust('round', props.Monto, -2)}
                    onChange={props.handleMontoPago}
                    // disabled={props.IdTipoPago === FPAY}
                    tabIndex="2"
                    onKeyDown={props.handlePagoEnterKeyUp}
                    style={{width: "25%"}}
                />

                {props.IdTipoPago !== PAGO_CREDITO ? (
                    <input
                        type="text"
                        className="item__detalle__pago"
                        placeholder="Ref."
                        value={props.Referencia}
                        onChange={props.handleReferenciaPago}
                        style={{width: "25%"}}
                    />
                ) : (
                    <input
                        type="date"
                        className="item__detalle__pago"
                        value={moment(props.fechaPago).format("YYYY-MM-DD")}
                        onChange={props.handleSelectPlazosCredito}
                        style={{width: "25%"}}
                    />
                )}

                {renderDeleteButton()}
            </div>

            {/* Versión Mobile - CON BADGES COLORIDOS */}
            <div className="items__detalle__pago botones-resp">
                <div className="card w-100" style={{padding: "15px"}}>
                    {/* Fila 1: Nombre del medio de pago y botón eliminar */}
                    <div className="row align-items-center mb-2">
                        <div className="col-8">
                            {paymentInfo && (
                                <span 
                                    className="badge p-2"
                                    style={{
                                        fontSize: "0.9rem",
                                        backgroundColor: badgeStyle.backgroundColor,
                                        color: badgeStyle.color,
                                        borderRadius: "10px",
                                        padding: "5px 12px"
                                    }}
                                >
                                    {paymentInfo.name}
                                </span>
                            )}
                        </div>
                        <div className="col-4 text-right">
                            {props.IdTipoPago !== FPAY && (
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={props.handleRemovePago}
                                    style={{padding: "2px 8px"}}
                                >
                                    <i className="fas fa-trash-alt"/>
                                </button>
                            )}
                        </div>
                    </div>
                    
                    {/* Fila 2: Campo de monto */}
                    <div className="row mb-3">
                        <div className="col-12">
                            <input
                                className="form-control"
                                type="number"
                                autoFocus
                                onFocus={props.handleFocus}
                                placeholder="Monto"
                                value={decimalAdjust('round', props.Monto, -2)}
                                onChange={props.handleMontoPago}
                                tabIndex="2"
                                onKeyDown={props.handlePagoEnterKeyUp}
                            />
                        </div>
                    </div>
                    
                    {/* Fila 3: Campo de referencia/fecha */}
                    <div className="row">
                        <div className="col-12">
                            {props.IdTipoPago !== PAGO_CREDITO ? (
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Referencia"
                                    value={props.Referencia}
                                    onChange={props.handleReferenciaPago}
                                />
                            ) : (
                                <input
                                    type="date"
                                    className="form-control"
                                    value={moment(props.fechaPago).format("YYYY-MM-DD")}
                                    onChange={props.handleSelectPlazosCredito}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetallePagoUI;